<div class="modal right" id="newOffer" tabindex="-1" role="dialog" aria-labelledby="newOfferLabel">
    <div class="modal-dialog" role="document">
        <div class="modal-content" id="print-content">
            <div class="modal-header hide-print">
                <div class="modal-title">
					<h4 id="newOfferLabel" ng-if="!offer.id">New Offer</h4>
                    <h4 id="newOfferLabel" ng-if="offer.id">Edit Offer</h4>
                </div>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <i class="icon-close-circle"></i>
                </button>
            </div>
            <div class="modal-body order-detail-page">
                <div class="modal-body-container">
					<div class="tab-content">
						<div class="tab-pane active">
							<div class="row">
								<div class="col-md-12">
									<form ng-submit="save()" class="form-horizontal allcp-form">
										<div class="form-group floating">
											<input id="datetimepicker" 
												date-range-picker
												placeholder="Date" 
												ng-model="offer.date"
												type="text" 
												class="form-control  input-md" 
												options="{drops: 'down', singleDatePicker: true, locale: { format: 'MM/DD/YYYY' } }"
												autocomplete="off"
												required>
											<label>Date</label>
										</div>
				
										<div class="form-group floating">
											<!-- <select id="type" autocomplete="off" class="form-control input-md" name="type" ng-model="offer.station_id" required>
												<option value="">Select Station</option>
												<option value="{{ item.id }}" ng-repeat="item in stations">{{ item.code }}</option>
											</select> -->
											<select 
												ng-model="offer.station_id" 
												class="form-control"
												ng-options="station.id as station.code for station in stations">
												<option value="">Select Station</option>
											</select>

											<label>Station</label>
										</div>

										<div class="row">
											<div class="col-md-6 pl15">
												<div class="form-group floating">
													<input id="startoffer" autocomplete="off" ng-change="calculatePrice()" type="text" class="form-control input-md" placeholder="Start Time" required ng-model="offer.start_time">
													<label>Start Time</label>
												</div>
											</div>
											<div class="col-md-6 pr10">
												<div class="form-group floating">
													<input id="endoffer" autocomplete="off" ng-change="calculatePrice()" type="text" class="form-control input-md" placeholder="End Time" required ng-model="offer.end_time">
													<label>End Time</label>
												</div>
											</div>
										</div>
				
										<div class="form-group floating">
											<input type="text" ng-model="offer.payout" ng-change="calculatePrice()" class="form-control input-md" placeholder="Offer Price" required>
											<label>Payout</label>
										</div>
										
										<div class="form-group floating">
											<input type="text" ng-model="offer.price" class="form-control input-md" placeholder="Offer Price" required disabled>
											<label>Price</label>
										</div>
										
										<div class="form-group floating">
											<input type="text" ng-model="offer.worker_count" class="form-control input-md" placeholder="Offer Count" required>
											<label>Offer Count </label>
										</div>
										<div class="form-group floating">
											<select id="type" name="type" ng-model="offer.wehicle" class="form-control input-md" required>
												<option value="">Select Wehicle</option>
												<option value="Small">Small</option>
												<option value="Medium">Medium</option>
												<option value="Large">Large</option>
											</select>
											<label>
												Wehicle
											</label>
										</div>

										<div class="form-group">
											<label>Receiver</label>
											<div class="radio-custom radio-info mb15">
												<input type="radio" name="types" id="yes" ng-model="offer.receiver" ng-value="1" checked ng-checked="true">
												<label for="yes" class="pt5">All Drivers</label>
												<input type="radio" name="types" id="no" ng-model="offer.receiver" ng-value="0">
												<label for="no" class="pt5">Selected Drivers</label>
											</div>
										</div>

										<div class="form-group floating" ng-if="!offer.receiver">
											<ui-select
												multiple
												ng-model="offer.receivers"
												theme="bootstrap"
												sortable="true"
												class="form-control input-md"
												style="width: 100%; padding-top:8px !important"
												title="Drivers">
												<ui-select-match placeholder="Drivers...">{{$item.full_name}}</ui-select-match>
												<ui-select-choices repeat="item in data.workers | filter:$select.search">
													{{item.full_name}}
												</ui-select-choices>
											</ui-select>
										</div>

										<div class="form-group floating pln">
											<div class="col-md-12 pln">
												<button type="submit" class="hod-button blue">
													<span ng-if="!offer.id">CREATE</span>
                    								<span ng-if="offer.id">UPDATE</span>
												</a>
											</div>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
            </div>
        </div>
    </div>
</div>
